import { render, staticRenderFns } from "./RewardsList.vue?vue&type=template&id=0ec2b90e"
import script from "./RewardsList.vue?vue&type=script&lang=js"
export * from "./RewardsList.vue?vue&type=script&lang=js"
import style0 from "./RewardsList.vue?vue&type=style&index=0&id=0ec2b90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports